import script from "./application-handle.vue?vue&type=script&setup=true&lang=js"
export * from "./application-handle.vue?vue&type=script&setup=true&lang=js"

import "./application-handle.vue?vue&type=style&index=0&id=4497a4f9&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4497a4f9"]])

export default __exports__